var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 60,
    viewBox: "0 0 71 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58361_26023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4893 50.0862C59.449 55.6709 63.2505 59.1524 63.2505 59.1524L64.81 55.0423L69.4416 54.8402C69.4416 54.8402 65.4733 50.5067 62.8472 45.543",
    stroke: "#254B77",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5266 50.0824C46.5629 55.6693 42.7614 59.1524 42.7614 59.1524L41.202 55.0423L36.5703 54.8402C36.5703 54.8402 40.5348 50.5067 43.1609 45.543",
    stroke: "#254B77",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.179 46.5391H3.34931C2.32525 46.5391 1.49121 45.7166 1.49121 44.7024V2.74304C1.49121 1.72844 2.32525 0.90625 3.34931 0.90625H60.1705C61.1985 0.90625 62.0286 1.72844 62.0286 2.74304V20.0965",
    stroke: "#254B77",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9898 17.9763V10.8608C54.2123 10.8608 51.9586 8.63379 51.9586 5.88672H11.5654C11.5654 8.63379 9.3116 10.8608 6.53027 10.8608V36.5874C9.3116 36.5874 11.5654 38.8144 11.5654 41.5615H34.7508",
    stroke: "#254B77",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0186 13.8594H37.5046",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0166 18.8359H44.5063",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1805 33.5802C66.9671 32.4748 66.1447 31.6399 65.1207 31.3456C65.6288 30.4322 65.6172 29.2792 64.9926 28.3516C64.3875 27.4536 63.3634 26.9998 62.3471 27.0714C62.4169 26.0779 61.9669 25.0756 61.0747 24.4757C60.136 23.8425 58.9529 23.8283 58.018 24.335C57.7232 23.335 56.893 22.5262 55.7875 22.307C54.7169 22.0946 53.6656 22.4902 52.9984 23.2511C52.3389 22.4998 51.3033 22.1043 50.2443 22.3039C49.1232 22.514 48.2775 23.3285 47.9789 24.3396C47.0556 23.8387 45.888 23.8482 44.9493 24.4654C44.0416 25.0633 43.5838 26.0763 43.6537 27.081C42.6489 27.0116 41.6365 27.4543 41.0275 28.3367C40.3874 29.267 40.3719 30.4337 40.884 31.3563C39.8754 31.6484 39.0569 32.4706 38.8358 33.5626C38.6185 34.6205 39.0181 35.6577 39.79 36.3177C39.0297 36.9709 38.6263 37.9923 38.828 39.0407C39.0414 40.1461 39.8676 40.9813 40.8917 41.2757C40.3835 42.1891 40.3952 43.3421 41.0158 44.2696C41.621 45.1677 42.6489 45.6215 43.6653 45.5502C43.5955 46.543 44.0416 47.5453 44.9376 48.1456C45.8764 48.7784 47.0556 48.793 47.9905 48.2863C48.2892 49.2863 49.1193 50.0947 50.2249 50.3143C51.2955 50.5266 52.3468 50.1311 53.0139 49.3702C53.6734 50.1215 54.7091 50.517 55.7681 50.3177C56.8891 50.1073 57.7309 49.2928 58.0296 48.2816C58.9529 48.7826 60.1205 48.7726 61.0592 48.1556C61.9708 47.5576 62.4285 46.5446 62.3548 45.5403C63.3595 45.6096 64.3758 45.167 64.981 44.2846C65.6211 43.3539 65.6366 42.1875 65.1245 41.2646C66.137 40.9729 66.9555 40.1507 67.1766 39.0583C67.3938 38.0008 66.9943 36.9632 66.2223 36.3036C66.9826 35.6504 67.3822 34.6285 67.1805 33.5802Z",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0188 45.2534C50.0303 46.3868 45.0534 43.3089 43.909 38.3785C42.7608 33.4481 45.8758 28.5324 50.8643 27.399C55.8567 26.2655 60.8297 29.3434 61.9779 34.2738C63.1223 39.2042 60.0112 44.1199 55.0188 45.2534Z",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.791 34.5817C20.4249 34.5817 20.7779 30.3509 22.2714 30.1274C23.792 29.8994 23.823 33.5652 25.2893 33.4774C26.1272 33.4269 26.7168 32.8113 27.0543 32.2597C27.2405 31.9573 27.6789 31.9477 27.8689 32.2459L28.4547 33.1501C28.9629 33.6154 29.6844 33.7756 30.3399 33.5695L33.0747 32.7151",
    stroke: "#254B77",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52998 5.88739L6.21582 5.57422",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.835 5.88739L57.1492 5.57422",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21582 41.5631L6.52998 41.25",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58361_26023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.827e82ab2c503093592ad9fad863026b.svg";
export { ForwardRef as ReactComponent };